/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />
/// <reference path="../../_ext/Bases/DialogBase.ts" />
/// <reference path="../../_ext/Bases/GridBase.ts" />
namespace TabAurous.Inventory {

    import fld = SKURepricingDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class SKURepricingDetailsEditor extends _Ext.ItemGridEditor<SKURepricingDetailsRow> {



        protected getColumnsKey() { return "Inventory.SKURepricingDetails"; }
        protected getDialogType() { return SKURepricingDetailsDialog; }
        protected getLocalTextPrefix() { return SKURepricingDetailsRow.localTextPrefix; }
        protected form: SKURepricingDetailsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = true;
        private contractTotals: string;
        public TotalItems: number;
        statement: string;

        public currentrow: SKURepricingDetailsRow;
        public _row: number;
        // #endregion

        static Items: any[];
        static LineNo: number[];


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
        }



        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            //columns.push(
            //    {
            //        field: 'Generate SKU',
            //        name: 'SKU',
            //        format: ctx => '<a class="inline-action add-button gen-sku" href="#"><span></span>Genrate SKU</a>',
            //        width: 90,
            //        minWidth: 90,
            //        maxWidth: 90
            //    });

            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);



            var item = this.itemAt(row);
            var target = $(e.target);
            this.currentrow = this.itemAt(row);
            this._row = row;
            (this.parentDialog as SKURepricingDialog).form.SKUSelected.value = item.SKU;
            (this.parentDialog as SKURepricingDialog).form.ProductIdSelected.value = item.ProductId.toString();
            (this.parentDialog as SKURepricingDialog).form.AttributeIdSelected.value = item.AttributeId.toString();
            (this.parentDialog as SKURepricingDialog).form.LineNoSelected.value = item.Line_No.toString();

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);


                    });
                    this.view.refresh();
                }

                if (target.hasClass('gen-sku')) {
                    //set items on dialog open 
                    let recordId = item[this.getIdProperty()];//get id
                    this.editItem(recordId);//set as edit
                }
                this.view.refresh();


                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    //item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    //item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    //item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    //item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    //item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    //item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    //item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    //item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    //item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    //if (item.WstPer != null) {
                    //    item.WstWt = item.NetWeight * (item.WstPer / 100);
                    //}
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            //// *** Calculate Wastage ***
            //if (field === fld.WstPer && value >= 0) {
            //    item.WstWt = item.NetWeight * (value / 100);
            //    item[field] = value;
            //}

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.StockSelectGrid;

            buttons = buttons.filter(x => x.cssClass != "add-button");

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {
                    var filters: _Ext.SelectGridFilters = {

                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Items",
                        preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                    });


                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var self = this;
                        var details = [];
                        var companyId = Q.Authorization.userDefinition.CompanyId;



                        // #region Items to Grid

                        selectedItems2.forEach(function (Item: Stock.StockItemRow) {

                            var bomdetails = [];
                            for (var i = 0; i < Item.BOMDetails.length; i++) {
                                var oldbom = Item.BOMDetails[i];
                                var bom: SKURepricingDetailsBOMRow = {

                                    RefTransBomId: oldbom.StockBomId,
                                    ProductId: oldbom.ProductId,
                                    BOMProductId: oldbom.BOMProductId,
                                    BOMAttributeId: oldbom.BOMAttributeId,
                                    Lab: oldbom.Lab,
                                    CertificateNo: oldbom.CertificateNo,
                                    Pieces: oldbom.Pieces,
                                    Weight: oldbom.Weight,
                                    CalcOnId: oldbom.CalcOnId,
                                    SettingId: oldbom.SettingId,
                                    BomRate: oldbom.BomRate,
                                    SBomRate: oldbom.BomRate,
                                    BomAmount: oldbom.BomAmount,
                                    CCBomAmount: oldbom.BomAmount,
                                    Remarks: oldbom.Remarks,
                                    Purity: oldbom.Purity,
                                    PureWeight: oldbom.PureWeight,
                                    ProductCode: oldbom.ProductCode,
                                    ProductName: oldbom.ProductName,
                                    IsCustomerItem: oldbom.IsCustomerItem,
                                    ItemType: oldbom.ItemType,
                                    CostMethodId: oldbom.CostMethodId,
                                    CalcOn: oldbom.CalcOn,
                                    ItemTypeId: oldbom.ItemTypeId,
                                    ProductTypeId: oldbom.ProductTypeId,
                                    SubCategoryId: oldbom.SubCategoryId,
                                    CategoryId: oldbom.CategoryId,
                                    ProductTypeName: oldbom.ProductTypeName,
                                    CategoryName: oldbom.CategoryName,
                                    SubCategoryName: oldbom.SubCategoryName,
                                    Attribute: oldbom.Attribute,
                                    SieveId: oldbom.SieveId,
                                    GroupSieveId: oldbom.GroupSieveId,
                                    RefStockBomId: oldbom.StockBomId,
                                    TextureId: oldbom.TextureId,
                                    Parts: oldbom.Parts,
                                }
                                bomdetails.push(bom);
                            }
                            var detail: SKURepricingDetailsRow = {
                                ProductId: Item.ProductId,
                                AttributeId: Item.AttributeId,
                                Line_No: Item.Line_No,
                                PartyId: Item.PartyId,
                                SKU: Item.SKU,
                                DepartmentId: Item.DepartmentId,
                                ProductCode: Item.ProductCode,
                                ProductName: Item.ProductName,
                                ItemTypeId: Item.ItemTypeId,
                                CategoryId: Item.CategoryId,
                                ProductTypeId: Item.ProductTypeId,
                                SubCategoryId: Item.SubCategoryId,
                                BrandId: Item.BrandId,
                                SuperTypeId: Item.SuperTypeId,
                                CollectionId: Item.CollectionId,
                                UnitRate: Item.Rate,
                                Pieces: Item.Pieces,
                                Weight: Item.Weight,
                                OtherPieces: Item.OtherPieces,
                                OtherWeight: Item.OtherWeight,
                                StonePieces: Item.StonePieces,
                                Stoneweight: Item.StoneWeight,
                                NetWeight: Item.NetWeight,
                                NetAmount: Item.Rate,
                                GrossAmount: Item.CalcOnId == 3 ? Item.Rate * Item.Pieces : Item.Rate * Item.Weight,
                                DiamondPieces: Item.DiamondPieces,
                                DiamondWeight: Item.DiamondWeight,
                                CalcOnId: Item.CalcOnId,
                                CompanyId: companyId,
                                CostMethodId: Item.CalcOnId,
                                TransId: Item.TransId,
                                BOMDetails: bomdetails,
                                HasBom: Item.HasBom,
                                BagNo: Item.BagNo,
                                LotNo: Item.LotNo,
                                CertificateNo: Item.CertificateNo,
                                Lab: Item.Lab,
                                RefTransId: Item.TransId,
                                RefTransItemId: Item.TransItemId,
                                RefVoucherId: Item.VoucherTypeId,
                                StockId: Item.StockId,
                                DesignId: Item.DesignId,
                                UnitCost: Item.Rate,
                                Studded: Item.Studded,
                                RefNo: Item.RefNo,
                                MF: Item.MF,
                                MFAmount: Item.MFAmount,
                                Hsn: Item.HSN,
                                MetalId: Item.MetalId,
                                MetalColorId: Item.MetalColorId,
                                KaratId: Item.KaratId,
                                Purity: Item.Purity,
                                Hallmark: Item.Hallmark,
                                Parts: Item.Parts==null?1:Item.Parts,
                                ExportPieces: Item.ExportPieces

                            };
                            details.push(detail);

                        });

                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Detail);
                        }
                        (this.parentDialog as SKURepricingDialog).setItems(details);

                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }



    }
}